import { withMessage } from 'io-ts-types';
import * as t from 'io-ts';

export default (length: number) =>
  withMessage(
    t.brand(t.string, (s): s is any => s.length >= length, 'MinLength'),
    () => 'VALIDATION_MIN_LENGTH',
  );
